import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAssessment } from '../context/AssessmentContext';
import MCQSection from '../components/assessment/MCQSection';
import PhysicalTestsModule from '../components/physical/PhysicalTestsModule';
import nutritionQuestions from '../data/questions/nutrition.json';
import cognitiveQuestions from '../data/questions/cognitive.json';

const AssessmentPage = () => {
  const navigate = useNavigate();
  const { assessmentStep, personalInfo, currentAssessment } = useAssessment();

  useEffect(() => {
    // Redirect to home if no assessment started
    if (!personalInfo && !currentAssessment) {
      navigate('/');
    }
  }, [personalInfo, currentAssessment, navigate]);

  const handleNutritionComplete = async (responses) => {
    console.log('Nutrition assessment complete:', responses);
    // nextStep is already called in MCQSection, so we don't need to do anything here
  };

  const handleCognitiveComplete = async (responses) => {
    console.log('Cognitive assessment complete:', responses);
    // nextStep is already called in MCQSection, so we don't need to do anything here
  };

  const handlePhysicalComplete = (results) => {
    console.log('Physical assessment complete:', results);
    navigate(`/report/${currentAssessment?.id}`);
  };

  // Debug: Log current step
  console.log('Current assessment step:', assessmentStep);

  // Render based on current step
  if (assessmentStep === 'nutrition') {
    return (
      <MCQSection
        sectionType="nutrition"
        questions={nutritionQuestions}
        onComplete={handleNutritionComplete}
      />
    );
  }

  if (assessmentStep === 'cognitive') {
    return (
      <MCQSection
        sectionType="cognitive"
        questions={cognitiveQuestions}
        onComplete={handleCognitiveComplete}
      />
    );
  }

  if (assessmentStep === 'physical') {
    return <PhysicalTestsModule />;
  }

  // Default/Loading state
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-400">Loading assessment...</p>
        <p className="text-slate-500 text-sm mt-2">Step: {assessmentStep || 'unknown'}</p>
      </div>
    </div>
  );
};

export default AssessmentPage;
